document.addEventListener('DOMContentLoaded', () => {
  // Detectar todos los filtros (checkboxes, radios, selects) dentro del formulario de filtros
  const filterForm = document.querySelector('#FacetFiltersForm, #FacetFiltersFormMobile');

  if (filterForm) {
    filterForm.addEventListener('change', (event) => {
      // Enviar el formulario con recarga
      filterForm.submit();
    });
  }

  // Detectar select de ordenamiento
  const sortSelect = document.querySelector('#SortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', (event) => {
      // Recargar la página con el nuevo sort
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      window.location.href = url.toString();
    });
  }
});